import { BaseNomenclature } from "./baseNomenclature.model";

export class MonitoringFrequency extends BaseNomenclature {
    constructor(){
        super();
        this.collection_name="monitoring_frequency";
    }
}